<script setup>
import { useI18n } from 'vue-i18n';
import LaisCopyButton from 'dashboard/components-next/LaisCopyButton.vue';

defineProps({
  items: { type: Array, default: () => [] },
});

const { t } = useI18n();
</script>

<template>
  <dl class="grid gap-4 sm:grid-cols-2">
    <div v-for="item in items" :key="item.key" class="min-w-0">
      <dt
        class="text-xs font-bold uppercase tracking-wide text-lais-text-muted"
      >
        {{ item.label }}
      </dt>
      <dd
        class="mt-1 flex items-start gap-1 break-words text-sm text-lais-text-body"
      >
        <span class="min-w-0">
          {{ item.value ?? t('SALES.DETAIL.EMPTY_VALUE') }}
        </span>
        <LaisCopyButton
          v-if="item.copy && item.value"
          icon-only
          :text="String(item.value)"
          :aria-label="t('LAIS_COPY_BUTTON.TOOLTIP')"
        />
      </dd>
    </div>
  </dl>
</template>
